import React from "react";
import { Link } from "react-router-dom";
export default function ReportListItem(props) {
  const clickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
    }
  };

  const dblClickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
      props.onPick(props);
    }
  };

  return (
    <>
      <Link
        onClick={(e) => clickHandler(e)}
        onDoubleClick={(e) => dblClickHandler(e)}
        to={`/report/${props.mode}/${props.nodeId}/${props.id}/${props.itemMode}/`}
      >
        <div
          className={`row py-4 px-2 border-bottom text-dark bg-hover-light ${
            props.highlightItem === String(props.id) ? "bg-light" : ""
          }`}
        >
          <div className="col-lg-12 m-lg-0 my-3">
            <div>{props.label}</div>

            {props.description && (
              <div className="text-dark-75 small">{props.description}</div>
            )}
          </div>
        </div>
      </Link>
    </>
  );
}
